import api from "api/api";

export const getInternalTrainingByUserIdQuery = async ({ id, userScope }) =>
  await api.get(`/datatrack/internal_training/user/${id}?scope=${userScope}`);
